import { ChangeDetectionStrategy, Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { FirmwareUpdateState, RouterDto } from '../../api/core';

@Component({
    selector: 'liebherr-firmware-state',
    templateUrl: 'firmware-state.component.html',
    styleUrls: ['firmware-state.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FirmwareStateComponent implements OnChanges {
    @Input() device?: RouterDto;

    stateData$ = new BehaviorSubject<{ icon?: string; styleClass?: string } | undefined>(undefined);

    FW_STATE = FirmwareUpdateState;

    firmwareTooltipItems = ['downloadVersion', 'downloadAllowedTime', 'downloadAllowedBy', 'downloadTime', 'installedTime'];

    constructor() {}

    ngOnChanges(changes: SimpleChanges) {
        if (changes.device) {
            this.updateStateData();
        }
    }

    private updateStateData() {
        let icon: string | undefined;
        let styleClass: string | undefined;

        switch (this.device?.firmwareUpdateState) {
            // no icon for FirmwareUpdateState.Actual
            case FirmwareUpdateState.Downloading: {
                icon = 'watch_later';
                styleClass = 'active';
                break;
            }
            case FirmwareUpdateState.Forced:
            case FirmwareUpdateState.ForcedActivation:
            case FirmwareUpdateState.ForcedDownloading: {
                icon = 'warning';
                styleClass = 'warn';
                break;
            }

            case FirmwareUpdateState.NeedFwActivation:
            case FirmwareUpdateState.NeedFwActivationTriggered: {
                icon = 'play_circle';
                styleClass = 'active';
                break;
            }
            case FirmwareUpdateState.NeedFwUpdate:
            case FirmwareUpdateState.NeedFwUpdateTriggered: {
                icon = 'upload';
                styleClass = 'active';
                break;
            }

            default: {
                break;
            }
        }

        this.stateData$.next({ icon, styleClass });
    }
}
